import Router from './router';
import Storage from './storage';
import User from './user';
import Drive from './drive';
import Upload from './upload';
import Truck from './truck';
import Payment from './payment';
import Coupon from './coupon';
import City from './city';
import AddOn from './add-on';
import Business from './business';

export default {
    Router,
    Storage,
    User,
    Drive,
    Upload,
    Truck,
    Payment,
    Coupon,
    City,
    AddOn,
    Business,
};
